module.exports = __webpack_public_path__ + "img/question_mark.9d921693.png";